/**
 * The TipTap extension that hosts the tracking plugin.
 *
 * SEPARATE FROM THE MARKS because the plugin needs to read the CURRENT mode and author on every
 * transaction, and an extension configured once at editor creation would hold whatever they were
 * then -- so switching from Editing to Suggesting would do nothing until the page was reloaded.
 * It is given a getter rather than a value for exactly that reason.
 */
import { Extension } from "@tiptap/core";

import { SuggestionMode, suggestionPlugin } from "./suggestions";

export type SuggestionOptions = {
    get: () => { mode: SuggestionMode; author: { userId: string; userName: string } };
};

export const SuggestionTracking = Extension.create<SuggestionOptions>({
    name: "parkourSuggestionTracking",
    addOptions() {
        return { get: () => ({ mode: "editing" as SuggestionMode,
                               author: { userId: "", userName: "" } }) };
    },
    addProseMirrorPlugins() {
        return [suggestionPlugin(this.options.get)];
    },
});
